import Image from "next/image";
import auPayImage from "public/images/aupay.png";
import { memo } from "react";
import { RadioButton } from "src/components/elements/button/RadioButton";
import styles from "src/components/features/cart/confirm/PaymentSelection/AuPayButton/styles.module.scss";
type Props = {
  isSelected?: boolean;
  onSelect?: () => void;
};

export const AuPayButton = memo(({ isSelected = false, onSelect }: Props) => {
  return (
    <div>
      <div className={styles.creditCardButtonContainer}>
        <RadioButton isActive={isSelected} onPress={onSelect}>
          <div className={styles.cardInfo}>
            <Image
              src={auPayImage}
              alt="aupay"
              width={117}
              height={22}
              className={styles.logoImage}
            />
          </div>
        </RadioButton>
      </div>
    </div>
  );
});
